<template>
  <div class="jumbotron" style="margin-top: 10vh; margin-bottom: 0vh;">
    <div class="container">
      <h1 class="d-none d-lg-block display-3">Submitting Your Application</h1>
      <h1 class="d-md-block d-lg-none display-5">
        Submitting Your Application
      </h1>
      <p class="d-none d-lg-block lead">
        Before submitting your application for the RAINN Speakers Bureau, please
        ensure that all of the information that you have entered is correct and
        something that you are comfortable sharing. After verifying this, please
        click "Submit" and accept our Terms and Conditions.
      </p>
      <p class="d-md-block d-lg-none">
        Before submitting your application for the RAINN Speakers Bureau, please
        ensure that all of the information that you have entered is correct and
        something that you are comfortable sharing. After verifying this, please
        click "Submit" and accept our Terms and Conditions.
      </p>
      <button class="btn btn-primary btn-sm" type="button" @click="onSubmit">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onSubmit: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>
